import { Component, OnDestroy, OnInit } from '@angular/core';
import { GlobalHelper } from '@app/_shared/_helpers/global.helper';

@Component({
  selector: 'theme-POLO-cookie-notify',
  templateUrl: './cookie-notify.component.html',
  styleUrls: ['./cookie-notify.component.scss']
})
export class ThemePOLOCookieNotifyComponent implements OnInit, OnDestroy{

  cookiesIsAccepted = null

  subscriptions: any = [];
  constructor(public globalHelper:GlobalHelper) {

    this.subscriptions.push(this.globalHelper.cookiesIsAccepted.subscribe((cookiesIsAccepted) => {
      this.cookiesIsAccepted = cookiesIsAccepted;
    }));

  }

  ngOnInit(): void {
    console.log('CookiesIsAccepted',this.globalHelper.cookiesIsAccepted)
  }
  ngOnDestroy(){
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
  accept(){
    this.globalHelper.CookiesAccept()
  }
  reject(){
    this.globalHelper.CookiesReject()
  }

}
